import { Card, CardContent } from "@mui/material";

interface CustomProps {
  children?: any;
  removeLastChildBottomPadding?: boolean;
}

const CenteredCardLayout = (props: CustomProps) => {
  return (
    <>
      {props.children && (
        <Card>
          <CardContent
            sx={{
              padding: 0,
              "&:last-child": {
                paddingBottom: props.removeLastChildBottomPadding
                  ? "0px"
                  : "32px",
              },
            }}
          >
            {props.children}
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default CenteredCardLayout;
